<template>
  <section class="SettingsAcc">
    <main class="main" :class="{ 'expand-main': isMenuCollapse }">
      <Header :user="user" />
      <div class="col-md-12">
        <div v-if="alert.message">
          <div class="mt-4">
            <AlertError :msgError="alert.message" />
          </div>
        </div>
      </div>
      <component
        :is="SettingsTabComponent"
        ref="childView"
        :subscriptionData="this.subscriptionData"
      ></component>
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Header from "@/components/Header.vue";
import Account from "@/components/Account/Account.vue";
import BlackList from "@/components/Account/BlackList.vue";
import ViewBilling from "@/components/Billing/ViewBilling.vue";
import AgencyData from "@/components/Agencies/AgencyData.vue";
import EmailSettings from "@/components/Account/EmailSettings.vue";
import ClientTeam from "@/components/Account/ClientTeam.vue";
import { billingsService, usersService, crmService } from "@/_services";
import CustomFields from "@/components/Contacts/CustomFields.vue";
import Integrations from "@/components/Account/Integrations.vue";
import OliverSettings from "@/components/Account/OliverSettings.vue";
import CampaignStepTemplateConfig from "@/components/Account/CampaignStepTemplateConfig.vue";
import AlertError from "@/components/AlertError.vue";

export default {
  components: {
    Header,
    Account,
    ViewBilling,
    BlackList,
    AgencyData,
    EmailSettings,
    ClientTeam,
    CustomFields,
    Integrations,
    OliverSettings,
    CampaignStepTemplateConfig,
    AlertError,
  },
  mounted() {
    window.onbeforeunload = null;
    this.udpdateHeader(this.$route.name);
  },

  computed: {
    ...mapState({
      headerTab: (state) => state.header.tab,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      toSettingAccount: (state) => state.onboarding.toSettingAccount,
      alert: (state) => state.alert,
    }),

    user() {
      return this.$store.state.authentication.user;
    },

    subscriptionData() {
      let recurring_payment_period = 1;
      if (this.$route.query.annual == 1) {
        recurring_payment_period = 12;
      }
      return {
        plan_id: this.$route.query.plan_id,
        recurring_payment_period: recurring_payment_period,
      };
    },

    SettingsTabComponent() {
      //If this component is called from Onboarding -> complete your profile
      if (this.toSettingAccount) {
        this.goToSettingAccount(false);
        this.changeHeaderTab({ tab: "ACCOUNT" });
        return "account";
      }
      if (this.headerTab === "ACCOUNT") {
        return "account";
      } else if (this.headerTab === "AGENCYDATA") {
        return "AgencyData";
      } else if (this.headerTab === "EMAILSETTINGS") {
        return "EmailSettings";
      } else if (this.headerTab === "TEAM") {
        return "ClientTeam";
      } else if (this.headerTab === "CUSTOMFIELDS") {
        return "CustomFields";
      } else if (this.headerTab === "INTEGRATIONS") {
        return "Integrations";
      } else if (this.headerTab === "OLIVERSETTINGS") {
        return "OliverSettings";
      } else if (this.headerTab === "CAMPAIGNSTEPTEMPLATE") {
        return "CampaignStepTemplateConfig";
      } else if (this.headerTab === "BLACKLIST") {
        return "BlackList";
      } else if (this.headerTab === "BILLING") {
        return "ViewBilling";
      } else {
        if (this.hasPermissions("adminClients")) {
          this.changeHeaderTab({ tab: "ACCOUNT" });
          return "account";
        }
        if (this.user.is_agency == 1 && this.user.role_id == 3) {
          this.changeHeaderTab({ tab: "EMAILSETTINGS" });
          return "EmailSettings";
        }
        this.changeHeaderTab({ tab: "BILLING" });
        return "ViewBilling";
      }
    },
  },
  created() {
    this.$store.dispatch("alert/clear");
    this.getAllOptionsList();
    if (
      typeof this.$route.params.section === "undefined" &&
      this.$route.query.code &&
      this.$route.query.state
    ) {
      usersService
        .verificationAuthenticationCode(
          this.$route.query.code,
          this.$route.query.state
        )
        .then(
          (result) => {
            // if (this.user.role_id == 1) {
            //   this.$router.push({
            //     path: "/users/" + result,
            //   });
            // }

            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
            return true;
          },
          (error) => {
            this.$store.dispatch(
              "alert/newError",
              { message: error, section: "emailsettings" },
              { root: true }
            );
            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
            return true;
          }
        );
    }
    if (this.$route.query.synchronisation) {
      this.changeHeaderTab({ tab: "EMAILSETTINGS" });
      return true;
    }
    if (this.$route.query.blacklist) {
      this.changeHeaderTab({ tab: "BLACKLIST" });
      return true;
    }

    if (this.$route.query.mycustomfields) {
      this.changeHeaderTab({ tab: "CUSTOMFIELDS" });
      return true;
    }

    if (this.$route.query.contractualdata) {
      window.location.href = "https://oliverlist.com/terms-of-services/";
      // this.changeHeaderTab({ tab: "AGENCYDATA" });
      // return true;
    }

    if (
      this.$route.query.billing ||
      this.$route.query.profile ||
      this.$route.query.invoices
    ) {
      this.changeHeaderTab({ tab: "PAYMENT" });
      return true;
    }

    if (this.$route.query.integrations) {
      this.changeHeaderTab({ tab: "INTEGRATIONS" });
      return true;
    }

    if (
      this.$route.query.email &&
      this.$route.query.grant_id &&
      this.$route.query.provider
    ) {
      if (true || this.$route.query.success === "true") {
        let data = {
          email: this.$route.query.email,
          grant_id: this.$route.query.grant_id,
          provider: this.$route.query.provider,
          success: this.$route.query.success,
        };
        usersService.setNylasIntegration(data).then(
          (result) => {
            let type = result;
            let title = this.$t("lang.label.great");
            let message = this.$t("lang.integrations." + result);
            this.$swal({
              type: type,
              title: title,
              text: message,
              showConfirmButton: false,
              timer: 8000,
            });
            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
            return;
          },
          (error) => {
            
            this.$swal({
              type: "warning",
              title: this.$t("lang.label.error"),
              html: this.$t("lang.general.error"),
              showConfirmButton: true,
            });
            this.changeHeaderTab({ tab: "EMAILSETTINGS" });
          }
        );
      }
    }

    if (this.user.is_agency != 1 && this.user.is_sales == 1) {
      this.changeHeaderTab({ tab: "EMAILSETTINGS" });
      return true;
    }

    if (typeof this.$route.params.section !== "undefined") {
      if (this.$route.params.section == "payment") {
        let ingenicoResponse = {
          id: this.$route.params.type,
          ncerror: this.$route.query.NCERROR,
          ingenico_status: this.$route.query.STATUS,
        };
        billingsService
          .confirmPaymentMethod(ingenicoResponse)
          .then((result) => {
            let type = result;
            let title = this.$t("lang.label.great");
            let message = this.$t("lang.paymentmethod." + result);
            if (result == "error") {
              title = this.$t("lang.label.error");
            }
            this.$swal({
              type: type,
              title: title,
              text: message,
              showConfirmButton: true,
            }).then((result) => {
              const { dispatch } = this.$store;
              dispatch("authentication/refreshToken").then((result) => {
                this.$router.push("/dashboard");
              });
            });
          });
      } else if (this.$route.params.section == "integrations") {
        if (this.$route.params.type !== undefined) {
          crmService
            .authorize(this.$route.query.code, this.$route.params.type)
            .then(
              (result) => {
                let type = result;
                let title = this.$t("lang.label.great");
                let message = this.$t("lang.integrations." + result);
                this.$swal({
                  type: type,
                  title: title,
                  text: message,
                  showConfirmButton: false,
                  timer: 8000,
                });
                this.changeHeaderTab({ tab: "INTEGRATIONS" });
              },
              (error) => {
                this.$swal({
                  type: "error",
                  title: this.$t("lang.label.error"),
                  text: this.$t("lang.label.error"),
                  showConfirmButton: true,
                });
                this.changeHeaderTab({ tab: "INTEGRATIONS" });
              }
            );
        }
      } else {
        this.changeHeaderTab({});
      }
    } else {
      this.changeHeaderTab({});
    }
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("optionsList", {
      getAllOptionsList: "getAll",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    ...mapActions("onboarding", {
      goToSettingAccount: "goToSettingAccount",
    }),
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: "" });
    },
  },
};
</script>
<style>
.SettingsAcc .header {
  margin-left: 0px;
}
section.SettingsAcc {
  overflow-x: hidden;
}
</style>